export default __webpack_public_path__ + "static/media/buttons4.0ccf10b4.jpg";